import { CollaborationPlatform } from './types'

/**
 * 识别当前 H5 所在的协同客户端。
 *
 * <p>识别结果只用于向后端提供候选平台；是否允许登录及实际使用的应用配置由后端最终校验。</p>
 */
export function detectCollaborationPlatform(): CollaborationPlatform | null {
    if (typeof navigator === 'undefined') return null

    const userAgent = navigator.userAgent.toLowerCase()
    if (userAgent.includes('wxwork')) return CollaborationPlatform.WXCP
    if (userAgent.includes('dingtalk')) return CollaborationPlatform.DINGTALK
    if (userAgent.includes('feishu') || userAgent.includes('lark')) return CollaborationPlatform.FEISHU
    return null
}

export function isCollaborationAutoLoginEnabled(platform: CollaborationPlatform | null): boolean {
    if (!platform) return false
    const configured = String(import.meta.env.VITE_COLLABORATION_AUTO_LOGIN ?? '').trim().toLowerCase()
    if (configured) return configured === 'true' || configured === '1'
    // 仅兼容企业微信旧开关，不再使用旧 URL 拼接授权地址。
    return platform === CollaborationPlatform.WXCP && !!String(import.meta.env.VITE_WECOM_URLLOGIN || '').trim()
}
